export const LOGIN = 'LOGIN';
export const CONFIRM_REGISTRATION = 'CONFIRM_REGISTRATION';
export const REGISTRATION_CHILDREN = 'REGISTRATION_CHILDREN';
export const LAYOUT = 'LAYOUT';
export const ADD_CHILD = 'ADD_CHILD';
export const EDIT_CHILD = 'EDIT_CHILD';
export const ACTIVITIES = 'ACTIVITIES';
export const CHILDREN = 'CHILDREN';
export const ACCOUNT = 'ACCOUNT';
export const RECEIPTS = 'RECEIPTS';
export const CALENDAR = 'CALENDAR';
export const PROFILE = 'PROFILE';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const ERRORS = 'ERRORS';
export const SHOPPING_CART = 'SHOPPING_CART';
export const CLASSES_WIDGET = 'CLASSES_WIDGET';
export const CAMPS_WIDGET = 'CAMPS_WIDGET';
export const AFTERCARE_WIDGET = 'AFTERCARE_WIDGET';
export const ACTIVITIES_WIDGET = 'ACTIVITIES_WIDGET';


// WEBPACK FOOTER //
// ./src/router/names.js